import React from "react";
import CrudModule from "@/components/CrudModule";
import { money } from "@/lib/api";

export default function Inventory() {
  return (
    <CrudModule
      title="Inventory"
      subtitle="Bulk LPG, cylinders, accessories, regulators, valves, hoses & gauges."
      endpoint="inventory"
      testid="inventory"
      columns={[
        { key: "name", label: "Item" },
        { key: "category", label: "Category" },
        { key: "quantity", label: "Qty", align: "right", render: (v, r) => (
          <span className={Number(v) <= Number(r.reorder_level) ? "text-destructive font-semibold" : ""}>{v} {r.unit}</span>
        ) },
        { key: "reorder_level", label: "Reorder", align: "right" },
        { key: "price", label: "Unit Price", align: "right", render: (v) => money(v) },
      ]}
      fields={[
        { key: "name", label: "Item Name", full: true },
        { key: "category", label: "Category", type: "select", options: ["Cylinders", "Bulk LPG", "Accessories", "Regulators", "Valves", "Hoses", "Gauges"] },
        { key: "quantity", label: "Quantity", type: "number" },
        { key: "reorder_level", label: "Reorder Level", type: "number" },
        { key: "unit", label: "Unit", type: "select", options: ["unit", "gal", "ft", "kg"] },
        { key: "price", label: "Unit Price (BZ$)", type: "number" },
      ]}
    />
  );
}
